function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Magic } from "devlink/Magic";
import { convertToMagicTag, getRunningPromptsText, wrapTextInMarkupLanguage } from "./utils";
import DefaultProps from "./default-props";
function DevlinkMagicComponent(_param) {
    var { tags = [], runningPrompts, mainHeadlineText, subHeadline, tagsTitle, cta } = _param, props = _object_without_properties(_param, [
        "tags",
        "runningPrompts",
        "mainHeadlineText",
        "subHeadline",
        "tagsTitle",
        "cta"
    ]);
    const magicTags = useMemo(()=>tags.reduce((acc, tag, index)=>_object_spread({}, acc, convertToMagicTag(tag, index)), {}), [
        tags
    ]);
    return /*#__PURE__*/ _jsx(Magic, _object_spread(_object_spread_props(_object_spread({}, props), {
        variant: cta === null || cta === void 0 ? void 0 : cta.color,
        runningPrompts: getRunningPromptsText(runningPrompts),
        mainHeadlineText: wrapTextInMarkupLanguage(mainHeadlineText),
        subHeadline: wrapTextInMarkupLanguage(subHeadline),
        tagsTitle: wrapTextInMarkupLanguage(tagsTitle),
        ctaText: wrapTextInMarkupLanguage(cta === null || cta === void 0 ? void 0 : cta.text)
    }), magicTags));
}
DevlinkMagicComponent.defaultProps = DefaultProps;
export default DevlinkMagicComponent;
